module.exports = __webpack_public_path__ + "static/img/fish30.0490c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish30.png
// module id = 7Zty
// module chunks = 0